<template>
<div>
  <div class="nav-search-box">
    <div ref="search">
      <div class="nav-search">
        <project-search fromPage="projectDetail" @getProjectCode="getProjectCode" />
      </div>
  </div>
  </div>
  <div class="project-detail">
    <div ref="header" class="header">

        <a-anchor :offsetTop=80 :target-offset="targetOffset">
          <a-anchor-link href="#picture" title="项目信息" />
          <a-anchor-link href="#houseType" title="热销户型" />
          <a-anchor-link v-if="activityNumList.length" href="#activity" title="热门活动" />
          <a-anchor-link v-if="dynamicListData.length" href="#dynamic" title="楼盘动态" />
          <a-anchor-link v-if="advisersDataList.length" href="#adviser" title="精选顾问" />
          <a-anchor-link href="#around" title="楼盘周边" />
        </a-anchor>
    </div>
    <div class="contain" id="picture">
      <div class="left-section">
        <ProjectPicture></ProjectPicture>
      </div>
      <div class="right-section">
        <ProjectInfo :projectCode="projectCode" :info="basicInfo" :tags="projectDetail.tags"></ProjectInfo>
      </div>

    </div>
    <HotHouseType :houseInfo="projectDetail.houseInfo" id="houseType"></HotHouseType>
    <HotActivity :projectCode="projectCode" id="activity"></HotActivity>
    <ProjectDynamic v-if="dynamicListData.length" :projectCode="projectCode" id="dynamic"></ProjectDynamic>
    <Adviser @advisersData="advisersData" :projectCode="projectCode" id="adviser"></Adviser>
    <Around :projectCode="projectCode" :info="basicInfo" v-if="projectInfoReady" id="around"></Around>
  </div>
</div>
</template>

<script>
import ProjectPicture from './components/ProjectPicture/Index.vue'
import HotHouseType from './components/HotHouseType/Index.vue'
import HotActivity from './components/HotActivity/Index.vue'
import ProjectDynamic from './components/ProjectDynamic/Index.vue'
import Adviser from './components/AdviserCom/Index.vue'
import Around from './components/AroundCom/Index.vue'
import ProjectInfo from './components/ProjectInfo.vue'
import ProjectSearch from "@/components/ProjectSearch.vue"
import { mapGetters } from 'vuex'
import swTracker from '@/mixins/tracker.js'

export default {
  name: "project-detail",
  mixins: [swTracker],
  components: {
    ProjectPicture,
    HotHouseType,
    HotActivity,
    ProjectDynamic,
    Adviser,
    Around,
    ProjectInfo,
    ProjectSearch
  },
  data () {
    return {
      projectCode: '',
      projectDetail: {},
      basicInfo: {},
      offsetTop: 0,
      offsetHeight: 0,
      offsetSearchTop: 0,
      offsetSearchHeight: 0,
      headerFixed: 0,
      targetOffset: undefined,
      dynamicListData: {},
      activityNumList: {},
      advisersDataList: [],
    }
  },
  computed: {
    ...mapGetters(['homePage']),
    ...mapGetters(['businessCard']),
    projectInfoReady () {
      return Object.keys(this.basicInfo).length
    },
  },
  async created () {
    const projectCode = this.$route && this.$route.query && this.$route.query.projectCode
    this.projectCode = projectCode
    await this.getProjectDetail()
    this.getChatOfficialUser()
  },
  mounted(){
    this.getDynamic()
    this.getActivities()
    window.scrollTo(0,0);
    this.$nextTick(() => {

      // 获取吸顶元素的dom
      let header = this.$refs.header;
      // 吸顶元素到top的距离
      this.offsetTop = header.offsetTop;
      // 元素自身的高度
      this.offsetHeight = header.offsetHeight;
      // 监听滚动条
      window.addEventListener("scroll", this.throttle(this.handleScroll,100));
    });
    this.targetOffset = window.innerHeight / 2.5;
    let chArr = document.getElementsByClassName("ant-anchor-ink");

    for( var i=0;i<chArr.length;i++ ){
        //删除元素 元素.parentNode.removeChild(元素);
        if (chArr[i] != null)
          chArr[i].parentNode.removeChild( chArr[i]);
    }
  },

  destroyed() {
    window.removeEventListener('scroll', this.handleScroll,100);
  },
  methods: {
    advisersData (data) {
      this.advisersDataList = data
    },
    getActivities(){
      const params = {
        page: 1,
        limit: 10,
        homePageId: this.homePage.id,
        locationId: 2,
        projectCode: this.projectCode
      }
      this.$api.getActivities(params).then(res => {
        this.activityNumList = res.data.list || []
      })
    },
    getDynamic () {
      let params = {
        projectCode: this.projectCode,
        limit: 100
      }
      this.$api.getDynamic(params).then(res => {
        if (res.code === 200) {
          this.dynamicListData = res.data && res.data.list
        }
      })
    },
    async getProjectCode (code) {
      this.projectCode = code
      await this.getProjectDetail()
      this.getChatOfficialUser()
    },
    throttle (fn,delay) {
      let open = true;
      return function() {
        if (open == true) {
          open = false;
          setTimeout(() => {
              fn();
              open = true;
          }, delay);
        }
      };
    },
    handleScroll() {
      // 得到页面滚动的距离
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // 判断页面滚动的距离是否大于吸顶元素的位置

      this.searchFixed = scrollTop;
    },
    getProjectDetail () {
      return new Promise(resolve => {
        this.$api.getProjectDetail(this.projectCode).then(res => {
          if (res.code === 200) {
            this.projectDetail = res.data
            this.basicInfo = res.data.basicInfo
            this.$store.commit('SET_PROJECTDETAIL', res.data)
            resolve()
          }
        })
      })
    },
    async getChatOfficialUser () {
      const res = await this.$store.dispatch('setVisitorExtraInfo', { projectCode: this.projectCode })
      await this.$store.dispatch('setBusinessCard', res && res.shareId) // 官方顾问
      this.$set(this.basicInfo, 'officialPhone', this.businessCard && this.businessCard.phone)
    },
  }
}
</script>
<style lang="scss" scoped>
.nav-search-box{
  width: 100%;
  height: 120px;
  background: #F5F5F6;
  .nav-search{
    height: 120px;
    background: #F5F5F6;
    width: 100%;
    margin: 0 auto;
    width: 100%;
    padding-top: 35px;
    .project-search{
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
      left: 50%;
      margin-left: -590px;
    }
  }
}
.project-detail{
  width: 1180px;
  margin: 0 auto;
  padding-top: 40px;
  .header{
    width: 100%;
    height: 54px;
    text-align: left;
    .ant-anchor-wrapper{
       background: #F9F9F9;
      .ant-anchor{
        .ant-anchor-link{
          display: inline-block;
          font-size: 16px;
          font-weight: 500;
          font-family: MicrosoftYaHeiSemibold;
          color: #333333;
          padding: 16px;
        }
        .ant-anchor-link-title-active {
          border-bottom: 1px solid black;
        }
      }
    }
  }
  //  .issFixed {
  //   position: fixed;
  //   width: 1180px;
  //   top: 0px;
  //   z-index: 4;
  // }
  .contain{
    display: flex;
    position: relative;
    justify-content: space-between;
    align-items: top;
    padding-top: 32px;
    .left-section{
      width: 60.2%;
    }
    .right-section{
      width: 39.8%;
      box-sizing: border-box;
      padding-left: 42px;
    }
  }
}
::v-deep .ant-affix{
  z-index: 1001;
}
::v-deep .ant-anchor{
  height: 51px;
  overflow: hidden;
  z-index: 3;
  .ant-anchor-link-title-active {
    color: white !important;
  }
}
</style>
